module.exports = __webpack_public_path__ + "static/media/filename (18).b049cf18.png";